import athenaClient from "lib/axios/clients";
import buildRequestUrl from "lib/requests/requestUtils";
import _ from "lodash";

const getFetchDataForCompetitorConfig = (mainScenarioId, position) => ({
  method: "GET",
  url: buildRequestUrl({}, `competitors/config/${mainScenarioId}/${position}`),
});

const getFetchDataToCreateConfigKpis = (mainScenarioId, sliderData) => ({
  method: "POST",
  url: buildRequestUrl({}, "competitors/kpis"),
  data: {
    scenario_base_id: mainScenarioId,
    slider_prices: sliderData,
  },
});

export const getAsyncBasicCompetitorsData = async (mainScenarioId) => {
  let resultForCompetitorsConfigurationsArray = [];
  try {
    resultForCompetitorsConfigurationsArray = await Promise.allSettled([
      athenaClient(getFetchDataForCompetitorConfig(mainScenarioId, 0)),
      athenaClient(getFetchDataForCompetitorConfig(mainScenarioId, 1)),
      athenaClient(getFetchDataForCompetitorConfig(mainScenarioId, 2)),
    ]);
  } catch (e) {
    // For how are developed these requests, when we get a 404 error
    // it means that there are no scenarios created for these scenario - id
    // so, we need to catch that error and do nothing
    if (e.response.status !== 404) {
      throw e;
    }
  }

  const tasksToFetchCreateConfigKpis = [];
  const resultForCompetitorsKpisArray = [];
  _.map(resultForCompetitorsConfigurationsArray, (competitorConfig) => {
    if (competitorConfig.status === "fulfilled") {
      tasksToFetchCreateConfigKpis.push(
        athenaClient(
          getFetchDataToCreateConfigKpis(
            mainScenarioId,
            competitorConfig.value.data.slider_prices
          )
        )
      );
      resultForCompetitorsKpisArray.push(competitorConfig.value.data);
    }
  });

  let taskDataArray = [];
  if (tasksToFetchCreateConfigKpis.length > 0) {
    const responseForAsyncTasks = await Promise.all(
      tasksToFetchCreateConfigKpis
    );
    taskDataArray = _.reduce(
      responseForAsyncTasks,
      (prev, currTask, index) => {
        prev.push({
          taskData: currTask,
          name: resultForCompetitorsKpisArray[index].name,
          comment: resultForCompetitorsKpisArray[index].comment,
          sliderData: resultForCompetitorsKpisArray[index].slider_prices,
        });
        return prev;
      },
      []
    );
  }
  return taskDataArray;
};
export const getAsyncCustomCompetitorData = async ({
  scenarioId,
  sliderPrices,
  name,
  comment,
}) => {
  const responseForAsyncTask = await athenaClient(
    getFetchDataToCreateConfigKpis(scenarioId, sliderPrices)
  );

  const taskDataArray = {
    taskData: responseForAsyncTask,
    name,
    comment,
    sliderData: sliderPrices,
  };
  return taskDataArray;
};
